import type { ChartData } from '../types'

export const getLatestSeries = (series: ChartData['series']) => {
  // 後端 series 可能是空陣列，因此需要判斷 series 有值才使用 data 的資料
  return series?.[series.length - 1] ?? { data: [0] }
}

export default getLatestSeries
